import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/context/AuthContext";

export default function InstructorPracticalTrainingWrites({ learnerId, programmeId }) {
  const [state, setState] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    if (!learnerId) return Promise.resolve();
    return api
      .get("/access-workflow/instructor/practical-training-writes", {
        params: { learner_id: learnerId, programme_id: programmeId || "programme-nz-road-code" },
      })
      .then((res) => setState(res.data))
      .catch((err) => setError(formatApiError(err)));
  }, [learnerId, programmeId]);

  useEffect(() => {
    load();
  }, [load]);

  async function act(path) {
    setBusy(true);
    setError("");
    try {
      await api.post(`/access-workflow/instructor/practical-training-writes/${path}`, {
        learner_id: learnerId,
        programme_id: programmeId || "programme-nz-road-code",
        reason,
      });
      await load();
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  }

  if (!learnerId) return null;

  return (
    <section className="card space-y-2" data-testid="instructor-practical-training-writes">
      <h3 className="font-semibold text-sm">Practical feedback & sketches</h3>
      <p className="text-xs text-muted-foreground">
        Separate from access hold/resume. Assignment and advanced access must be in place before enabling new
        practical work.
      </p>
      {state && (
        <p className="text-sm" data-testid="practical-writes-status">
          Status: <strong>{state.practical_training_writes || "paused"}</strong>
          {state.guidance && !state.writes_allowed ? ` — ${state.guidance}` : ""}
        </p>
      )}
      <label className="text-xs block">
        Reason (optional)
        <input className="input mt-1" value={reason} onChange={(e) => setReason(e.target.value)} />
      </label>
      <div className="flex flex-wrap gap-2">
        <button type="button" className="btn-primary" disabled={busy} onClick={() => act("enable")}>
          Enable practical training
        </button>
        <button type="button" className="btn-outline" disabled={busy} onClick={() => act("pause")}>
          Pause new practical work
        </button>
      </div>
      {error && <p className="text-destructive text-sm">{error}</p>}
    </section>
  );
}
